import {
    TopToolbar,
    CreateButton,
    Pagination,
    useGetIdentity,
    ListBase,
    Title,
    ListToolbar,
    useListContext,
    SortButton,
    FilterButton,
} from 'react-admin';

import { ImageList } from './GridList';
import { SupplierListFilter } from './SupplierListFilter';
import { Chip, Stack } from '@mui/material';

const QuickFilter = ({ label }: { label: string; source: string; defaultValue?: boolean }) => (
    <Chip sx={{ marginBottom: 1 }} label={label} />
);

const supplierFilters = [
    <QuickFilter source="inativos" label="Incluir Inativos" defaultValue={true} />,
    <QuickFilter source="possui_comprador" label="Possui Comprador" defaultValue={true} />,
    <QuickFilter source="semana_par" label="Semana Par" defaultValue={true} />,
    <QuickFilter source="semana_impar" label="Semana Ímpar" defaultValue={true} />,
];

export const SupplierList = () => {
    const { identity } = useGetIdentity();
    if (!identity) return null;
    return (
        <ListBase perPage={24} filter={{ 'possui_skus': true }} sort={{ field: 'id', order: 'DESC' }} >
            <SupplierListLayout />
        </ListBase >
    );
};

const SupplierListLayout = () => {
    const { isPending } = useListContext();

    if (isPending) return null;

    return (
        <Stack direction="row" component="div">
            <SupplierListFilter />
            <Stack sx={{ width: '100%' }}>
                <Title title={'Suppliers'} />
                <ListToolbar filters={supplierFilters} actions={<SupplierListActions />} />
                <ImageList />
                <Pagination rowsPerPageOptions={[12, 24, 48, 96]} />
            </Stack>
        </Stack>
    );
};

const SupplierListActions = () => {
    return (
        <TopToolbar>
            <FilterButton disableSaveQuery />
            <SortButton fields={['data_cadastro', 'nome_fornec']} />
            <CreateButton
                variant="contained"
                label="Novo fornecedor"
                sx={{ marginLeft: 2 }}
            />
        </TopToolbar>
    );
};
